// Mục checklist (task list của GFM) trong một đoạn Markdown — dùng chung cho giao diện (lib/viec.ts, lib/checklist-viec.ts)
// và server (đánh dấu bước trong mô tả nội bộ: functions/api/viec/[so]/thong-tin.ts). Hàm thuần.
//
// Đúng THỨ TỰ trình duyệt vẽ ô đánh dấu: "- [ ] …", "* [x] …", "+ [ ] …", "1. [ ] …", lồng nhau, trong trích dẫn
// "> - [ ] …". Bỏ qua khối code ``` / ~~~: "- [ ]" trong code không phải ô đánh dấu, đếm nhầm là lệch thứ tự → đánh dấu
// nhầm mục.
const MUC_CL = /^((?:[ \t]*>)*[ \t]*(?:[-*+]|\d+[.)])[ \t]+)\[( |x|X)\](?=[ \t])/;

export function cacMucChecklist(than: string): { dong: number; xong: boolean }[] {
  const kq: { dong: number; xong: boolean }[] = [];
  let rao: string | null = null;
  (than || '').split('\n').forEach((d, i) => {
    const m_rao = d.match(/^[ \t]{0,3}(`{3,}|~{3,})/);
    if (m_rao) {
      if (!rao) rao = m_rao[1][0];
      else if (m_rao[1][0] === rao) rao = null;
      return;
    }
    if (rao) return;
    const m = d.match(MUC_CL);
    if (m) kq.push({ dong: i, xong: m[2] !== ' ' });
  });
  return kq;
}

// Đảo mục thứ `thu_tu` (0 = mục đầu). Ngoài phạm vi → trả nguyên văn.
export function doiMucChecklist(than: string, thu_tu: number): string {
  const muc = cacMucChecklist(than)[thu_tu];
  if (!muc) return than;
  return datMucChecklist(than, thu_tu, !muc.xong);
}

// Đặt mục thứ `thu_tu` về đúng trạng thái `xong` (đặt tường minh: bấm hai lần liên tiếp không bật rồi tắt). Ngoài phạm vi → nguyên văn.
export function datMucChecklist(than: string, thu_tu: number, xong: boolean): string {
  const muc = cacMucChecklist(than)[thu_tu];
  if (!muc) return than;
  const dong = than.split('\n');
  dong[muc.dong] = dong[muc.dong].replace(MUC_CL, (_, dau: string) => `${dau}[${xong ? 'x' : ' '}]`);
  return dong.join('\n');
}

// Chữ thuần của một dòng Markdown: bỏ **đậm**, `code`, [chữ](link) → chữ. Dùng cho checklist chép sang chat / Excel.
export const chuThuan = (md: string) =>
  md.replace(/!?\[([^\]]*)\]\([^)]*\)/g, '$1').replace(/(\*\*|__|~~|`)/g, '').replace(/\s+/g, ' ').trim();

// Các bước kèm chữ: `thu_tu` khớp thứ tự của cacMucChecklist / ô đánh dấu vẽ trên màn hình.
export function cacBuoc(than: string): { thu_tu: number; xong: boolean; chu: string }[] {
  const dong = (than || '').split('\n');
  return cacMucChecklist(than).map((m, thu_tu) => ({ thu_tu, xong: m.xong, chu: chuThuan(dong[m.dong].replace(MUC_CL, '')) }));
}
